export default "__VITE_ASSET__CEbFONGa__"